import useFetch from 'use-http';
import { useEffect, useState } from 'react';
import { LINB_API } from '../../constants/api-urls';
import { pmSensorAuthIdSelector } from 'state/selectors/sensors-authorizations';
import { useSelector } from 'react-redux';
import { normalizeProviderEntitiesData } from 'views/root/views/home/views/settings/views/ProjectManagement/services/project-management.service';
import { SHORTCUT_ENTITIES_TYPES } from 'common/constants/constants';

const useShortcutEntities = () => {
  const pmSensorAuthId = useSelector(pmSensorAuthIdSelector);
  const [data, setData] = useState([]);
  const projectsAPI = useFetch(
    `${LINB_API.PM_SERVICE.ENTITIES.SHORTCUT.PROJECTS}?sensor_authorization_id=${pmSensorAuthId}`
  );
  const teamsAPI = useFetch(
    `${LINB_API.PM_SERVICE.ENTITIES.SHORTCUT.TEAMS}?sensor_authorization_id=${pmSensorAuthId}`
  );

  const normalizeEntities = (projects, teams) => {
    const normalizedProjects = normalizeProviderEntitiesData(projects);
    const normalizedTeams = normalizeProviderEntitiesData(teams);
    normalizedProjects.forEach(
      project => (project.entityType = SHORTCUT_ENTITIES_TYPES.PROJECT)
    );
    normalizedTeams.forEach(
      team => (team.entityType = SHORTCUT_ENTITIES_TYPES.TEAM)
    );
    return [...normalizedProjects, ...normalizedTeams];
  };

  const fetchEntities = async () => {
    const [projects, teams] = await Promise.all([
      projectsAPI.get(),
      teamsAPI.get()
    ]);
    const entities = normalizeEntities(projects, teams);
    setData(entities);
  };

  useEffect(() => {
    if (pmSensorAuthId) fetchEntities();
  }, [pmSensorAuthId]);

  return {
    data,
    loading: projectsAPI.loading || teamsAPI.loading,
    error: projectsAPI.error || teamsAPI.error
  };
};

export default useShortcutEntities;
